{
  "blocks": [
    {
      "id": "test-cbc",
      "kind": "test",
      "tags": ["testing", "her", "pre-cycle", "practical"],
      "title": "CBC",
      "subtitle": "Screens for anemia and infection before fertility treatment",
      "body": {
        "testName": "Complete Blood Count (CBC)",
        "category": "blood-marker",
        "whatItMeasures": "Overall blood health: red cells, white cells, platelets, hemoglobin. Screens for anemia and infection before fertility treatment.",
        "howItWorks": "Routine blood draw, any lab. No fasting required. Part of standard pre-cycle workup.",
        "quickFacts": [
          {
            "kind": "sample",
            "value": "Blood"
          },
          {
            "kind": "time",
            "value": "5 min draw"
          },
          {
            "kind": "pain",
            "value": "Needle pinch"
          },
          {
            "kind": "prep",
            "value": "No fasting usually"
          },
          {
            "kind": "results",
            "value": "Same day to 1 business day"
          }
        ],
        "turnaroundTime": "same day to 1 business day",
        "costRange": {
          "low": 15,
          "high": 50
        },
        "atHome": false,
        "clinicRequired": false,
        "dataPoints": []
      },
      "sources": [
        {
          "title": "Prepregnancy Counseling (Committee Opinion No. 762)",
          "authors": "American College of Obstetricians and Gynecologists",
          "journal": "Obstetrics & Gynecology",
          "year": 2019,
          "url": "https://www.acog.org/clinical/clinical-guidance/committee-opinion/articles/2019/01/prepregnancy-counseling",
          "evidenceLevel": "guideline"
        }
      ],
      "readTimeMinutes": 2
    }
  ],
  "relationships": [],
  "localeVariants": []
}
